import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 md:mb-8 max-w-lg mx-auto lg:mx-0">
                {appData.description}
              </p>

              <div className="grid grid-cols-2 gap-3 md:gap-4 max-w-md mx-auto lg:mx-0 mb-6 md:mb-8">
                {appData.features.map((feature) => (
                  <div
                    key={feature}
                    className="flex items-center gap-2 px-3 py-2 rounded-md bg-background-100 border border-background-200/70"
                  >
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                    <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line"></i>
                  安卓版下载
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-sm lg:max-w-none">
              <div className="relative rounded-lg overflow-hidden bg-background-100 border border-background-200/70 p-4">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20Chinese%20streaming%20app%20interface%20with%20drama%20series%20thumbnails%2C%20warm%20golden%20and%20cream%20color%20scheme%2C%20minimalist%20UI%20design%2C%20clean%20layout%20with%20poster%20grid%2C%20premium%20product%20photography%2C%20soft%20studio%20lighting%2C%20elegant%20presentation&width=800&height=1000&seq=app-mockup-7788&orientation=portrait"
                  alt="7788电影网移动客户端"
                  title="7788电影网移动客户端追剧界面"
                  className="w-full h-auto rounded-md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}